import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.815 4.07817C11.0617 3.83153 11.0617 3.43163 10.815 3.18499C10.5684 2.93834 10.1685 2.93834 9.92183 3.18499L7 6.10681L4.07817 3.18499C3.83153 2.93834 3.43163 2.93834 3.18499 3.18499C2.93834 3.43163 2.93834 3.83153 3.18499 4.07817L6.10681 7L3.18499 9.92183C2.93834 10.1685 2.93834 10.5684 3.18499 10.815C3.43163 11.0617 3.83153 11.0617 4.07817 10.815L7 7.89319L9.92183 10.815C10.1685 11.0617 10.5684 11.0617 10.815 10.815C11.0617 10.5684 11.0617 10.1685 10.815 9.92183L7.89319 7L10.815 4.07817Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }